import { Action, ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { EligibilityCheckActionDispatchTypes } from "../models/DispatchTypes/CheckEligibility";
import { EligibilityCheckDispatchTypes, EligibilityInformationActionDispatchTypes, ReferralRequestorActionDispatchTypes } from "../constants/ReferralRequestor";
import { CheckEligibility } from "../services/ReferralRequest";
import { EligibilityInformation, EligibilityPayload } from "../models/CheckEligibility";
import { configUrl } from "../constants/Config";
import { ReferralRequestor } from "../models/ReferralRequestor";

export const saveReferralRequestor: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    Action<ReferralRequestorActionDispatchTypes>
  >
> = (sessionData: ReferralRequestor) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralRequestorActionDispatchTypes.REFERRAL_REQUESTOR_INVOKE,
    });
    const response = sessionData
    sessionStorage.setItem("requestorInformation", JSON.stringify(response))
    dispatch({
      response: response,
      type: ReferralRequestorActionDispatchTypes.REFERRAL_REQUESTOR_SUCCESS,
    });
  };
};

export const checkEligibility: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    EligibilityCheckActionDispatchTypes
  >
> = (payload: EligibilityPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: EligibilityCheckDispatchTypes.CHECK_ELIGIBILITY_INVOKE,
    });
    const response = await CheckEligibility(
      configUrl,
      payload
    );

    dispatch({
      response: response.data,
      type: EligibilityCheckDispatchTypes.CHECK_ELIGIBILITY_SUCCESS,
    });
  };
};

export const saveEligibilityInformation: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    Action<EligibilityInformationActionDispatchTypes>
  >
> = (sessionData: EligibilityInformation) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: EligibilityInformationActionDispatchTypes.SET_ELIGIBILITY_INFORMATION_INVOKE,
    });
    const response = sessionData
    sessionStorage.setItem("checkEligibilityResponse", JSON.stringify(response));
    dispatch({
      response: response,
      type: EligibilityInformationActionDispatchTypes.SET_ELIGIBILITY_INFORMATION_SUCCESS,
    });
  };
};